import Component from "./component";

class Health extends Component {
  constructor(max) {
    super();
    this.max = max;
    this.hp = max;
  }

  get percentage() {
    return Math.round(this.hp / this.max * 100);
  }

  isInjured() {
    return this.hp <= this.max * 0.45;
  }

  isDead() {
    return this.hp <= 0;
  }
}

export default Health;
